// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 检查用户购买条件 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-order-link/check */
export async function strategyOrderLinkCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyOrderLinkCheckUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/strategy-order-link/check", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略产品购买链接信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-order-link/info */
export async function strategyOrderLinkInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyOrderLinkInfoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultStrategyOrderLinkResp>(
    "/strategy-order-link/info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
